<template>
<el-dialog title="添加常用方" :visible.sync="dialogFormVisible" :close="close" :append-to-body='true'>
        <el-form>
            <el-form-item label="常用方名称">
                <el-input v-model="usedName" autocomplete="off" maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="常用方拼音码">
                <el-input v-model="usedCode" autocomplete="off" maxlength="20" show-word-limit ></el-input>
            </el-form-item>
            <p>
                <span class="info-label">类型：</span>
                <el-select v-model="dosageForm" placeholder="请选择" size="mini" class="width30">
                    <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                    </el-option>
                </el-select>
            </p>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handler">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import vPinyin from '../../../src/lib/pinyin'

    export default {
        name: "add-used-dialog",
        data() {
            return {
                typeOptions: [{value: '选项1', label: '饮片'}], //中药有两种类型 饮片或者颗粒
                dosageForm:'饮片',
                dialogFormVisible: false,
                usedName:'',
                usedCode:'',
                drugLists: []
            }
        },
        props:{
            orderType: String,
            drugList: Array,
        },
        methods:{
            handler(){
                if (!this.usedName){
                    return this.$message.error('常用方名称不可为空')
                }
                this.dialogFormVisible = false
                this.checkUsedName(this.usedName, this.usedCode, this.dosageForm)

            },
            show() {
                this.dialogFormVisible = true;
            },
            close(){
                this.dialogFormVisible = false;
            },
            //常用方名称检验
            async checkUsedName(name, usedCode, dosageForm, id = null) {
                const {code, obj} = await this.$http("smarthos.recipe.usedorder.usedname.verify", {
                        usedType: this.orderType === 'CHINESE_RECIPE' ? 'CHINESE_USED' : 'WESTERN_USED',
                        usedName: name, //常用方名称
                        id: id //常用方id
                    },
                    'post',
                    true,
                    false
                )
                if (code == '0') {
                    this.insertUsed(name, usedCode, dosageForm)
                } else {
                    this.$message.error('已存在该常用方名称')
                }
            },
            //常用方保存
            async insertUsed(name, usedCode, dosageForm) {
                this.drugLists.forEach((d) => {
                    if (d.frequencyObj) {
                        d.frequencyCode = d.frequencyObj.split('/')[0]
                        d.frequencyName = d.frequencyObj.split('/')[1]
                    }
                })
                const {code, obj, msg} = await this.$http("smarthos.recipe.usedorder.insert", {
                    usedType: this.orderType === 'CHINESE_RECIPE' ? 'CHINESE_USED' : 'WESTERN_USED',
                    usedName: name,
                    usedCode: usedCode,
                    usedOrderInfoList: this.drugLists,
                    dosageForm: dosageForm
                });
                if (code == '0') {
                    this.$alert(`您的常用方“<span class="color_main">${name}</span>”保存成功，如需修改请在“常用方管理”功能内进行修改`, '常用方保存成功', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                    });
                }
            },

        },
        watch:{
            usedName:{
                handler(newV){
                    this.usedCode = vPinyin.chineseToPinYin(newV)
                }
            },
            drugList:{
                handler(newV){
                    this.drugLists = newV
                },
                immediate: true
            },

            dialogFormVisible:{
                handler(newV){
                    if (!newV){
                        this.usedName = ''
                        this.usedCode = ''
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>